import { LINEAR_CURVE } from '../../core/params/curve';
import { DEFAULT_PALETTE } from '../../core/palette';
import type { ParamSchema, SchemaValues } from '../../core/params/types';

export const HALFTONE_PARAMS = [
  {
    kind: 'enum',
    key: 'shape',
    label: 'Rastertyp',
    default: 'dot',
    group: 'Raster',
    options: [
      { value: 'dot', label: 'Punkt' },
      { value: 'line', label: 'Linie' },
      { value: 'cross', label: 'Kreuz' },
      { value: 'square', label: 'Quadrat' },
      { value: 'wave', label: 'Welle' },
      { value: 'concentric', label: 'Konzentrisch' },
    ],
  },
  {
    kind: 'float',
    key: 'pitch',
    label: 'Rasterweite',
    min: 2,
    max: 80,
    step: 0.5,
    scale: 'log',
    default: 11,
    unit: 'px',
    bulkRange: [5, 30],
    group: 'Raster',
  },
  {
    kind: 'float',
    key: 'angle',
    label: 'Rasterwinkel',
    min: 0,
    max: 180,
    step: 1,
    default: 45,
    unit: '°',
    group: 'Raster',
  },
  {
    kind: 'curve',
    key: 'sizeCurve',
    label: 'Punktgrössen-Kurve',
    default: LINEAR_CURVE,
    xLabel: 'Deckung',
    yLabel: 'Grösse',
    group: 'Raster',
  },
  {
    kind: 'float',
    key: 'maxSize',
    label: 'Maximalgrösse',
    min: 0.2,
    max: 1.6,
    step: 0.01,
    default: 0.72,
    unit: '×',
    group: 'Raster',
    tooltip: 'Anteil der Rasterweite, den ein voller Punkt einnimmt.',
  },

  {
    kind: 'bool',
    key: 'useDistance',
    label: 'An Distanz koppeln',
    default: false,
    group: 'Kopplung',
    tooltip: 'Statt der Deckung bestimmt der Abstand zum Text die Punktgrösse — ergibt weiche Auren.',
  },
  {
    kind: 'float',
    key: 'distanceReach',
    label: 'Reichweite',
    min: 5,
    max: 800,
    step: 1,
    scale: 'log',
    default: 180,
    unit: 'px',
    group: 'Kopplung',
    showIf: (v) => v.useDistance === true,
  },

  {
    kind: 'bool',
    key: 'cmyk',
    label: 'CMYK-Simulation',
    default: false,
    group: 'Druck',
    tooltip: 'Vier Rasterlagen mit den klassischen Druckwinkeln 15°, 75°, 0° und 45°.',
  },
  {
    kind: 'float',
    key: 'cmykSpread',
    label: 'Kanal-Deckkraft',
    min: 0.1,
    max: 1,
    step: 0.01,
    default: 0.62,
    group: 'Druck',
    showIf: (v) => v.cmyk === true,
  },

  {
    kind: 'float',
    key: 'opacity',
    label: 'Deckkraft',
    min: 0.05,
    max: 1,
    step: 0.01,
    default: 1,
    group: 'Farbe',
  },
  {
    kind: 'enum',
    key: 'colorMode',
    label: 'Farbmodus',
    default: 'solid',
    segmented: true,
    group: 'Farbe',
    options: [
      { value: 'solid', label: 'Einfarbig' },
      { value: 'gradient', label: 'Verlauf' },
    ],
    showIf: (v) => v.cmyk !== true,
  },
  {
    kind: 'palette',
    key: 'palette',
    label: 'Palette',
    default: { ...DEFAULT_PALETTE, paletteId: 'riso' },
    group: 'Farbe',
    showIf: (v) => v.cmyk !== true,
  },
] as const satisfies ParamSchema;

export type HalftoneValues = SchemaValues<typeof HALFTONE_PARAMS>;
